import React from 'react';
import PageHeader from '../components/PageHeader';
import Icon from '../components/Icon';
import Reveal from '../components/Reveal';
import CallToAction from '../components/CallToAction';
import useSeo from '../hooks/useSeo';
import { services } from '../data/site';

const engagements = [
  {
    title: 'Advisory',
    text: 'Short, focused engagements: feasibility studies, architecture and design reviews, and technology selection.',
  },
  {
    title: 'Project delivery',
    text: 'A scoped build with clear milestones, from proof-of-concept through prototype to a production-ready design.',
  },
  {
    title: 'Embedded partner',
    text: 'Ongoing development capacity that works alongside your team as a hardware, firmware or AI extension.',
  },
];

const Services = () => {
  useSeo('/services');

  return (
    <>
      <PageHeader eyebrow="Services" title="Hardware, software and AI, designed together.">
        From our base in Moncton, New Brunswick, we work with businesses across Atlantic Canada, from idea to prototype
        to production. We can take on the whole product or the one piece your team is missing.
      </PageHeader>

      <section className="container-site divide-y divide-ink-700">
        {services.map((service) => (
          <Reveal
            key={service.id}
            id={service.id}
            className="grid scroll-mt-16 gap-8 py-16 md:grid-cols-[auto_1fr_1fr] md:gap-12 md:py-20"
          >
            <div>
              <span className="grid h-14 w-14 place-items-center rounded-xl border border-signal-500/30 bg-ink-900 text-signal-400">
                <Icon name={service.icon} className="h-7 w-7" />
              </span>
            </div>
            <div>
              <h2 className="font-display text-2xl font-bold text-white md:text-3xl">{service.title}</h2>
              <p className="mt-4 leading-relaxed text-slate-400">{service.summary}</p>
            </div>
            <ul className="space-y-3">
              {service.details.map((detail) => (
                <li key={detail} className="flex gap-3 text-sm text-slate-300">
                  <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-signal-400" />
                  {detail}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-ink-700 bg-ink-900/50 py-24">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Ways to work together</p>
            <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold text-white md:text-4xl">
              Engagements that fit your stage.
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {engagements.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08} className="card p-8">
                <span className="font-mono text-sm text-signal-400">0{i + 1}</span>
                <h3 className="mt-4 font-display text-xl font-semibold text-white">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{item.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CallToAction title="Not sure where to start?" text="Tell us about the problem. We will help you scope it and suggest the most practical path forward." />
    </>
  );
};

export default Services;
